var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Question icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote-Form",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Approved---Quote---Desktop",
    transform: "translate(-768.000000, -2204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form/Field/Labelled-Copy-7",
    transform: "translate(373.000000, 2202.000000)",
    fill: "#000000",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 16,
    fontWeight: "bold",
    "line-spacing": 20
  }, /*#__PURE__*/React.createElement("text", {
    id: "Label"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "Estimated value of proposed building works (if known)"))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Question-circle/Solid-Copy",
    transform: "translate(768.000000, 2204.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0.0159090909 C10.8572069,0.0159090909 13.9840909,3.1427931 13.9840909,7 C13.9840909,10.8572069 10.8572069,13.9840909 7,13.9840909 C3.1427931,13.9840909 0.0159090909,10.8572069 0.0159090909,7 C0.0159090909,3.1427931 3.1427931,0.0159090909 7,0.0159090909 Z M7.56611909,10.1612384 L6.47794773,10.1612384 L6.47794773,11.2954545 L7.56611909,11.2954545 L7.56611909,10.1612384 Z M7.14307191,3.18181818 C6.35711661,3.18181818 5.73899767,3.42087625 5.2887151,3.89885452 C4.83843253,4.37683279 4.61336037,5.00853064 4.61363662,5.79339661 L4.61363662,5.79339661 L5.58692189,5.79339661 C5.60544748,5.32079508 5.68176188,4.95903708 5.81572682,4.70826047 C6.05407105,4.25757949 6.48375426,4.03217007 7.10532947,4.03217007 C7.60773256,4.03217007 7.96787566,4.1631419 8.18548228,4.42480985 C8.40322716,4.68661566 8.51203047,4.99557133 8.51203047,5.35181472 C8.51203047,5.60631368 8.43640733,5.85171354 8.28488455,6.08787645 C8.20165762,6.22257064 8.09313081,6.35161237 7.95930412,6.47513949 L7.95930412,6.47513949 L7.51303082,6.9059679 C7.08555961,7.31680587 6.80974944,7.68104544 6.6858768,7.99923807 C6.56172766,8.31729284 6.49979135,8.73612699 6.49979135,9.25601625 L6.49979135,9.25601625 L7.47307636,9.25601625 C7.47307636,8.79802841 7.52699414,8.4517113 7.6348297,8.21734065 C7.74266525,7.98283213 7.9753412,7.6966242 8.33271929,7.35857899 C8.82406233,6.89328431 9.14908975,6.54062541 9.30752507,6.30074015 C9.46623689,6.06071702 9.54545455,5.74817686 9.54545455,5.36284393 C9.54545455,4.7267344 9.32674192,4.2042257 8.88945491,3.79517997 C8.45230616,3.38627211 7.87013241,3.18181818 7.14307191,3.18181818 Z",
    id: "Oval"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d4424e2c017dee6b5edfa2cde828da88.svg";
export { ForwardRef as ReactComponent };